/* src/app/warehousing/pages/locations-labels/locations-labels.component.scss */
.labelSheet {
  display: flex;
  flex-flow: row wrap;
  gap: 2mm;
}
/*# sourceMappingURL=locations-labels.component.css.map */
